<template>
  <div>
    <v-autocomplete
      v-if="items !== null"
      :label="placeholder"
      :name="name"
      :ref="name"
      v-model="modelData"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      :search-input.sync="searchData"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
      :error-messages="error"
      :loading="loading"
      :disabled="disabled"
      :readonly="readOnly"
      :clearable="clearable"
      :no-data-text="noDataText"
      v-bind="settings"
      v-on="$listeners"
      outlined
      dense
      :class="error ? 'show-errors' : 'hide-error'"
    >
      <template v-slot:item="{ item }">
        <slot name="item" :item="item">
          <v-list-item-content>
            <v-list-item-title>
              {{ item[itemText] }}
            </v-list-item-title>
          </v-list-item-content>
        </slot>
      </template>
    </v-autocomplete>

    <v-text-field
      v-if="items === null && type !== 'textarea'"
      :label="placeholder"
      :type="type"
      :name="name"
      :ref="name"
      :append-icon="appendIcon"
      v-model="modelData"
      @change="updateValue"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
      :error-messages="error"
      @click:append="$emit('clickIconeEmit')"
      v-bind="settings"
      v-on="$on"
      :autocomplete="autocomplete"
      :disabled="disabled"
      :readonly="readOnly"
      outlined
      dense
      :class="error ? 'show-errors' : 'hide-error'"
    ></v-text-field>

    <v-textarea
      v-if="items === null && type === 'textarea'"
      :name="name"
      :label="placeholder"
      v-model="modelData"
      @change="updateValue"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
      :error-messages="error"
      @click:append="$emit('clickIconeEmit')"
      v-bind="settings"
      v-on="$on"
      :autocomplete="autocomplete"
      :disabled="disabled"
      :readonly="readOnly"
      outlined
      dense
      :class="error ? 'show-errors' : 'hide-error'"
    ></v-textarea>
  </div>

</template>

<script>
export default {
  name: 'SGPFormInputComponent',

  props: {
    error: {
      type: String
    },

    type: {
      type: String,
      required: true
    },

    value: {
      // type: Object,
      required: true
    },

    name: {
      type: String,
      required: false
    },

    placeholder: {
      type: String,
      required: false,
      default: ''
    },

    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    },

    autocomplete: {
      type: String,
      required: false,
      default: "on"
    },

    appendIcon: {
      type: String,
      required: false,
    },

    items: {
      type: Array,
      default: null
    },

    itemText: {
      type: String,
      default: 'text'
    },

    itemValue: {
      type: String,
      default: 'value'
    },

    searchInput: {
      type: String,
      default: ''
    },

    loading: {
      type: Boolean,
      default: false
    },

    clearable: {
      type: Boolean,
      default: false
    },

    noDataText: {
      type: String,
      default: 'Nenhum resultado encontrado'
    }
  },

  computed: {
    modelData: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value);
      }
    },

    settings () {
      return {
        ...this.$attrs,
        ...this.$on
      }
    }
  },

  methods: {
    updateValue() {
      this.$emit('input', this.value);
    },

  }
}
</script>

<style scoped>
input:readonly{
  background-color: #ccc;
}
</style>
